/*!
 * CalendarView - Vue calendrier FullCalendar (mois, semaine, jour) pour IconsView
 */

import { Calendar, Draggable } from 'fullcalendar';
import frLocale from '@fullcalendar/core/locales/fr';
import BaseView from './BaseView';

export default class CalendarView extends BaseView {
    constructor(plugin, name = 'calendar') {
        super(plugin, name);
    }

    createContainer(element) {
        const myself = this.plugin;
        const calendarLayout = $('<div class="iv__calendar-layout"></div>');
        myself.sidebar = $('<div class="iv__sidebar"><div class="iv__sidebar__header">' + __('Éléments intemporels') + '</div><div class="iv__sidebar__content iv__container"></div></div>');
        myself.calendarContainer = $('<div class="iv__calendar-container"></div>');

        calendarLayout.append(myself.sidebar);
        calendarLayout.append(myself.calendarContainer);

        this.container = calendarLayout;
        myself.container = calendarLayout;
        myself.sidebarContainer = myself.sidebar.find('.iv__sidebar__content');

        element.empty().append(this.container);
        myself.containerView.addClass('iv__view iv__view--' + this.name + ' view view-' + this.name);

        return this.container;
    }

    postCreateContainer() {
        const myself = this.plugin;
        const calendarTarget = myself.calendarContainer;
        if (!calendarTarget || !calendarTarget.length) return;

        // Déterminer la vue initiale
        let calendarInitialView = 'dayGridMonth';
        if (this.name === 'calendar-week' || myself.view === 'calendar-week') calendarInitialView = 'timeGridWeek';
        else if (this.name === 'calendar-day' || myself.view === 'calendar-day') calendarInitialView = 'timeGridDay';

        // Date initiale
        let calendarInitialDate = myself.date;
        if (!calendarInitialDate || !(calendarInitialDate instanceof Date) || isNaN(calendarInitialDate.getTime())) {
            calendarInitialDate = new Date();
        }

        if (myself.calendar) {
            try {
                myself.calendar.destroy();
            } catch (e) {}
        }

        myself.calendar = new Calendar(calendarTarget[0], {
            initialView: calendarInitialView,
            initialDate: calendarInitialDate,
            locale: frLocale,
            allDayText: 'Global',
            editable: true,
            firstDay: 1,
            height: 'parent',
            droppable: true,
            headerToolbar: {
                left: 'prev,next today',
                center: 'title',
                right: 'dayGridMonth,timeGridWeek,timeGridDay'
            },
            eventContent(arg) {
                const iconEl = arg.event.extendedProps.iconElement;
                if (iconEl && iconEl.length) {
                    const cloneEl = iconEl.clone(true, true);
                    return { domNodes: [cloneEl[0]] };
                }
                return { html: '<span>' + (arg.event.title || '') + '</span>' };
            },
            eventClick(info) {
                info.jsEvent.preventDefault();
                info.jsEvent.stopPropagation();
                const iconEl = info.event.extendedProps.iconElement;
                if (iconEl && iconEl.length) {
                    myself.iconTrigger(iconEl, 'leftClick');
                }
            },
            eventDrop(info) {
                const itemData = info.event.extendedProps.itemData;
                if (itemData && info.event.start) {
                    let newStart = info.event.startStr.substring(0, 19).replace('T', ' ');
                    let newEnd = info.event.endStr ? info.event.endStr.substring(0, 19).replace('T', ' ') : null;

                    if (newStart.length === 10) newStart += ' 00:00:00';
                    if (newEnd && newEnd.length === 10) newEnd += ' 00:00:00';

                    if (!newEnd) {
                        const dateFields = myself.getDateFields(itemData.type);
                        if (dateFields && dateFields.length > 1 && itemData.data) {
                            const origStartStr = itemData.data[dateFields[0]];
                            const origEndStr = itemData.data[dateFields[1]];
                            if (origStartStr && origEndStr) {
                                const parseLocal = (str) => {
                                    let s = str.replace(' ', 'T');
                                    if (s.length === 10) s += 'T00:00:00';
                                    return new Date(s);
                                };
                                const origStart = parseLocal(origStartStr);
                                const origEnd = parseLocal(origEndStr);

                                if (origStart && origEnd && !isNaN(origStart.getTime()) && !isNaN(origEnd.getTime())) {
                                    const durationMs = origEnd.getTime() - origStart.getTime();
                                    if (durationMs > 0) {
                                        const computedEnd = new Date(info.event.start.getTime() + durationMs);
                                        const pad = (n) => n < 10 ? '0' + n : n;
                                        if (info.event.allDay) {
                                            newEnd = computedEnd.getUTCFullYear() + '-' + pad(computedEnd.getUTCMonth() + 1) + '-' + pad(computedEnd.getUTCDate()) + ' ' +
                                                     pad(computedEnd.getUTCHours()) + ':' + pad(computedEnd.getUTCMinutes()) + ':' + pad(computedEnd.getUTCSeconds());
                                        } else {
                                            newEnd = computedEnd.getFullYear() + '-' + pad(computedEnd.getMonth() + 1) + '-' + pad(computedEnd.getDate()) + ' ' +
                                                     pad(computedEnd.getHours()) + ':' + pad(computedEnd.getMinutes()) + ':' + pad(computedEnd.getSeconds());
                                        }
                                    }
                                }
                            }
                        }
                    }

                    myself.submitDateChange(itemData, newStart, newEnd);
                }
            },
            eventReceive(info) {
                const itemData = info.event.extendedProps.itemData;
                if (itemData && info.event.start) {
                    let newStart = info.event.startStr.substring(0, 19).replace('T', ' ');
                    let newEnd = info.event.endStr ? info.event.endStr.substring(0, 19).replace('T', ' ') : null;

                    if (newStart.length === 10) newStart += ' 00:00:00';
                    if (newEnd && newEnd.length === 10) newEnd += ' 00:00:00';

                    myself.submitDateChange(itemData, newStart, newEnd);
                }
            },
            eventDragStop(info) {
                const sidebar = myself.sidebarContainer;
                if (!sidebar || !sidebar.length) return;

                const offset = sidebar.offset();
                const x = info.jsEvent.pageX;
                const y = info.jsEvent.pageY;

                if (x >= offset.left && x <= offset.left + sidebar.outerWidth() &&
                    y >= offset.top && y <= offset.top + sidebar.outerHeight()) {
                    const itemData = info.event.extendedProps.itemData;
                    if (itemData) {
                        myself.submitDateChange(itemData, null, null);
                    }
                }
            },
            eventResize(info) {
                const itemData = info.event.extendedProps.itemData;
                if (itemData && info.event.start) {
                    let newStart = info.event.startStr.substring(0, 19).replace('T', ' ');
                    let newEnd = info.event.endStr ? info.event.endStr.substring(0, 19).replace('T', ' ') : null;

                    if (newStart.length === 10) newStart += ' 00:00:00';
                    if (newEnd && newEnd.length === 10) newEnd += ' 00:00:00';

                    myself.submitDateChange(itemData, newStart, newEnd);
                }
            },
            datesSet(dateInfo) {
                myself.date = dateInfo.view.currentStart;
                const fcViewType = dateInfo.view.type;
                let ivView = 'calendar';
                if (fcViewType === 'timeGridWeek') ivView = 'calendar-week';
                else if (fcViewType === 'timeGridDay') ivView = 'calendar-day';

                if (myself.view !== ivView) {
                    myself.view = ivView;
                    myself.fixedView[myself.templateName] = ivView;
                }
            },
            eventDidMount(info) {
                $(info.el).on('contextmenu', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    const iconEl = info.event.extendedProps.iconElement;
                    if (iconEl && iconEl.length) {
                        myself.iconTrigger(iconEl, 'rightClick');
                    }
                    return false;
                });
            },
            dateClick(info) {
                const addActionName = myself.template && myself.template.view && myself.template.view.calendar && myself.template.view.calendar.action;
                if (!addActionName) return;

                const now = Date.now();
                if (myself._lastDateClick && myself._lastDateClickDate === info.dateStr && (now - myself._lastDateClick) < 400) {
                    myself._lastDateClick = null;
                    myself._lastDateClickDate = null;

                    const actionObj = clone(myself.options.actions && myself.options.actions[addActionName]);
                    if (actionObj) {
                        if (actionObj.url) {
                            const dateField = myself.template.view.calendar.field ?? 'date';
                            actionObj.url += '?' + dateField + '=' + info.dateStr;
                        }
                        myself.action(actionObj, myself.element.find('.iconGrid'));
                    }
                } else {
                    myself._lastDateClick = now;
                    myself._lastDateClickDate = info.dateStr;
                }
            },
        });

        myself.calendar.render();

        // Draggable pour la sidebar
        if (myself.sidebarContainer && myself.sidebarContainer.length) {
            new Draggable(myself.sidebarContainer[0], {
                itemSelector: '.iv__item',
                eventData: function (eventEl) {
                    const $el = $(eventEl);
                    const itemData = $el.data('data');
                    return {
                        title: itemData.label || '',
                        duration: '01:00',
                        editable: !!myself.getDateFields(itemData.type),
                        extendedProps: {
                            iconElement: $el,
                            itemData: itemData,
                        }
                    };
                }
            });
        }
    }

    renderIcon(data, container, subdir, path) {
        const myself = this.plugin;
        if (data.type === 'root') return true;

        const calIconSize = myself.getViewIconSize('calendar');
        myself.viewThumbsHeight = calIconSize;
        myself.viewThumbsWidth = calIconSize;
        myself.viewItemWidthRatio = 3;
        myself.viewItemThumbsMode = false;

        const currentType = this.getTypes(data);
        const currentClassAll = this.buildItemClasses(data, currentType, (data.class || data.cls || ''));

        const codeSubtext = [];
        const calendarFields = myself.getViewFields('calendar');
        if (data && calendarFields && calendarFields.length) {
            $.each(calendarFields, (indexView, view) => {
                const rawVal = (data.data && data.data[view]) ? data.data[view] : data[view];
                const subdata = myself.renderSubdata(rawVal, null, null, data);
                if (subdata) {
                    codeSubtext.push(subdata);
                }
            });
        }

        const code = '<div class="' + currentClassAll + '"><div class="iv__item__frame"><span class="iv__item__link"><span class="iv__item__image">' + myself.renderIconImage(calIconSize, data.icon, data, 'img') + '</span> '
                + '<label class="iv__item__label">'
                + '<span class="iv__item__name titre">' + data.label + '</span>'
                + ((codeSubtext.length > 0) ? '<span class="iv__item__data infos">' + codeSubtext.join('') + '</span>' : '')
                + '</label></span></div></div>';

        const currentIcon = $(code);
        this.attachItemEvents(currentIcon, currentIcon, data, currentType, path);
        this.renderBadge(data, currentIcon);

        if (myself.calendar) {
            const extractDate = function (val) {
                if (!val) return null;
                if (typeof val === 'string') return val;
                if (val instanceof Date) return val.toISOString();
                if (typeof val === 'object' && val.date) return val.date;
                return null;
            };

            const dateFields = myself.getDateFields(data.type);
            const rawDate = data.date;
            let eventStart = null;
            let eventEnd = null;
            let allDay = true;

            if (rawDate) {
                if (Array.isArray(rawDate) && rawDate.length >= 2) {
                    eventStart = extractDate(rawDate[0]);
                    eventEnd = extractDate(rawDate[1]);
                } else if (Array.isArray(rawDate) && rawDate.length === 1) {
                    eventStart = extractDate(rawDate[0]);
                } else {
                    eventStart = extractDate(rawDate);
                }
            }

            if (eventStart) {
                if (typeof eventStart === 'string') eventStart = eventStart.replace(' ', 'T');
                if (eventEnd && typeof eventEnd === 'string') eventEnd = eventEnd.replace(' ', 'T');

                const tStart = eventStart.includes('T') ? eventStart.split('T')[1] : '';
                const isZeroStart = !tStart || tStart.startsWith('00:00');

                if (!eventEnd) {
                    if (isZeroStart) {
                        allDay = true;
                    } else {
                        allDay = false;
                        const d = new Date(eventStart);
                        if (isNaN(d.getTime())) {
                            allDay = true;
                        } else {
                            d.setMinutes(d.getMinutes() + 30);
                            const pad = (n) => n < 10 ? '0' + n : n;
                            eventEnd = d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + 'T' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':00';
                        }
                    }
                } else {
                    allDay = false;
                    const tEnd = eventEnd.includes('T') ? eventEnd.split('T')[1] : '';
                    const isZeroEnd = !tEnd || tEnd.startsWith('00:00');
                    if (isZeroStart && isZeroEnd) {
                        allDay = true;
                    }
                }

                myself.calendar.addEvent({
                    id: data.id,
                    title: data.label || '',
                    start: eventStart,
                    end: eventEnd || undefined,
                    allDay: allDay,
                    color: data.color || undefined,
                    editable: !!myself.getDateFields(data.type),
                    extendedProps: {
                        iconElement: currentIcon,
                        itemData: data,
                    }
                });

                if (myself.items !== undefined) {
                    myself.items.push(currentIcon);
                }
                return currentIcon;
            } else if (myself.sidebarContainer) {
                container = myself.sidebarContainer;
            } else {
                eventStart = new Date().toISOString().split('T')[0];
                myself.calendar.addEvent({
                    id: data.id,
                    title: data.label || '',
                    start: eventStart,
                    allDay: true,
                    editable: !!myself.getDateFields(data.type),
                    extendedProps: {
                        iconElement: currentIcon,
                        itemData: data,
                    }
                });
                if (myself.items !== undefined) {
                    myself.items.push(currentIcon);
                }
                return currentIcon;
            }
        }

        container.append(currentIcon);
        return currentIcon;
    }

    destroy() {
        if (this.plugin && this.plugin.calendar) {
            try {
                this.plugin.calendar.destroy();
                this.plugin.calendar = null;
            } catch (e) {}
        }
    }
}
